import { render, staticRenderFns } from "./search-keywords-minimal.vue?vue&type=template&id=19e545b2&scoped=true&"
import script from "./search-keywords-minimal.vue?vue&type=script&lang=js&"
export * from "./search-keywords-minimal.vue?vue&type=script&lang=js&"
import style0 from "./search-keywords-minimal.vue?vue&type=style&index=0&id=19e545b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e545b2",
  null
  
)

export default component.exports